module.exports = __webpack_public_path__ + "static/img/p6.98ca436.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/20250903/szr/p6.png
// module id = dfoR
// module chunks = 0